<template>
  <div class="w-full">
    <div
      class="grid grid-cols-2 md:grid-cols-4 gap-3"
      :class="loadingImages ? '!w-0 !h-0' : ''"
    >
      <div
        v-for="(image, index) in (images ? images : defaultGallery)"
        :key="index"
      >
        <Transition
          name="pop"
          appear
        >
          <img
            loading="lazy"
            class="block w-full object-cover max-h-57"
            :src="image.src"
            :alt="image.name"
            @load="checkImagesLoaded"
            @error="checkImagesLoaded"
          >
        </Transition>
      </div>
    </div>

    <PhotoGalleryImageLoader
      v-if="loadingImages"
      class="grid grid-cols-2 md:grid-cols-4 gap-3"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';

import {
  Default1,
  Default2,
  Default3,
  Default4,
  Default5,
  Default6,
  Default7,
  Default8,
} from '@/assets/images/components/app-gallery';

import PhotoGalleryImageLoader from '@/components/loaders/PhotoGalleryImageLoader.vue';

const props = defineProps({
  images: {
    type: Array,
    default: () => null,
  },
});

const defaultGallery = [
  { name: 'default image 1', src: Default1 },
  { name: 'default image 2', src: Default2 },
  { name: 'default image 3', src: Default3 },
  { name: 'default image 4', src: Default4 },
  { name: 'default image 5', src: Default5 },
  { name: 'default image 6', src: Default6 },
  { name: 'default image 7', src: Default7 },
  { name: 'default image 8', src: Default8 },
];

const loadingImages = ref(true);
const imagesToLoad = ref(props.images ? props.images.length : defaultGallery.length);

const checkImagesLoaded = () => {
  imagesToLoad.value--;

  if (imagesToLoad.value <= 0) {
    setTimeout(() => {
      loadingImages.value = false;
    }, 300);
  }
};

</script>
